import { Link, NavLink } from "react-router-dom";

const Vyayamshala = () => {
    return (
        <div className="max-w-5xl mx-auto px-4 py-8">
            <h1 className="text-3xl font-bold mb-6 text-left"> 
               व्यायाम शाळा
            </h1>
            <div className="h-0.5 w-full bg-orange-500 mb-6"></div>

            <p className="text-gray-700 mb-4 text-left">
                ग्रामपंचायत चांडोली खुर्दच्या वतीने तरुणांसाठी व्ययामशाळा उपलब्ध करून देण्यात आलेली आहे. सदर व्यायामशाळेसाठी ग्रामपंचायतीने विविध साहित्य उपलब्ध करून दिलेली आहेत.गावतील तरुण मुले व्यायामशाळेमध्ये दररोज व्ययाम करण्यासाठी येतात. 
            </p>
        </div>
    );
}


export default Vyayamshala;